interface JQuery
{
	draggable(element?: HTMLElement | string): void;
	visible(state?: boolean): boolean;
	hasScrollBar(horizontal?: boolean): boolean;
}

jQuery.prototype.draggable = function (element?: HTMLElement | string)
{
	this.mousedown((emd: JQueryMouseEventObject) =>
	{
		let startingXPosition = emd.clientX;
		let startingYPosition = emd.clientY;

		// Moving
		$(document).mousemove((emm: JQueryMouseEventObject) => 
		{
			if (!(emm.clientX == startingXPosition && emm.clientY == startingYPosition))
			{
				let elementToDrag: JQuery = this;
				if (element != null)
					elementToDrag = $(element);

				elementToDrag.offset({ top: emm.clientY, left: (emm.clientX - ($(this[0]).width() / 2)) });
			}
		});

		// Stop moving
		$(document).mouseup(() =>
		{
			$(document).unbind("mouseup");
			$(document).unbind("mousemove");
		});
	});
}

jQuery.prototype.visible = function (state?: boolean)
{
	if (state != null)
	{
		if (state) this.show();
		else this.hide();
	}
	return this.is(":visible");
}

jQuery.prototype.hasScrollBar = function (horizontal: boolean = false): boolean
{
	if (this.get(0) == null)
		return false;

	if (!horizontal)
		return this.get(0).scrollHeight > this.get(0).clientHeight;
	else
		return this.get(0).scrollWidth > this.get(0).clientWidth;
}